export default "__VITE_ASSET__hPn6U8eY__"